<template>
    <div class="financial-card-wrapper">
        <BottomCard :width="width" :max-width="maxWidth">
            <div class="financial-card-inner-wrapper">
                <h2 class="header">
                    {{header}}
                </h2>
                <div class="toggle-wrapper">
                   <slot name="toggle"></slot>
                </div>
                <div
                  v-if="subHeader"
                  class="sub-header"
                >
                    {{subHeader}}
                </div>
                <slot name="content" :max-width="maxWidth"></slot>

                <div class="capture-and-share cursor-pointer">
                    <span v-if="captureBtn"><i class="fas fa-camera"></i> เก็บภาพ{{header}}</span>
                </div>
            </div>
        </BottomCard>
    </div>
</template>

<script>
import BottomCard from "../../commons/BottomCard";

export default {
  name: "financial-card",
  components: {
    BottomCard
  },
  props: {
    // Props to receive
    // width ( type: Number, required: false, description: 'Width as a percentage of parent component')
    // max-width ( type:Number, required: false, description: 'Max width of the card')
    // header ( type:String, required: false, description: 'Header of the card')
    // subHeader ( type:String, required: false, description: 'Sub header of the card')
    // captureBtn ( type:Boolean, required: false, description: 'Showing capture btn or not')
    // shareBtn ( type:Boolean, required: false, description: 'Showing share btn or not')
    // captureFunction ( type: Funcntion, required: false, description: 'Function to call when user click at capture btn')
    // shareFunction ( type: Funcntion, required: false, description: 'Function to call when user click at share btn')

    width: {
      type: Number,
      default: 100
    },
    maxWidth: {
      type: Number,
      default: 1200
    },
    header: {
      type: String,
      default: ""
    },
    subHeader: {
      type: String,
      default: ""
    },
    captureBtn: {
      type: Boolean,
      default: true
    },
    shareBtn: {
      type: Boolean,
      default: true
    },
    captureFunction: {
      type: Function,
      default: () => {}
    },
    shareFunction: {
      type: Function,
      default: () => {}
    }
  },
  mounted() {}
};
</script>

<style lang='scss' scoped>
.financial-card-wrapper {
   @extend %container-style;
  h2 {
    margin: 0px;
    line-height: inherit;
    letter-spacing: inherit;
  }

  .financial-card-inner-wrapper {
    padding-bottom: 25px;
    .header {
      font-size: 23px;
      font-weight: bold;
      display: inline-block;
      color: #000000;
    }
    .sub-header {
      margin-top: 6px;
      margin-bottom: 20px;
      font-size: 15px;
      color: $finno-orange;
    }
    .capture-and-share {
      font-size: 16px;
      color: $finno-orange;
      margin-top: 25px;
      span:not(:first-child) {
        margin-left: 15px;
      }
    }
    .toggle-wrapper {
      float: right;
      vertical-align: text-top;
      margin-left: 20px;
    }
  }
}

@media screen and (max-width: 420px) {
  .financial-card-wrapper {
    margin: 0px 0px 10px 0px;
    .financial-card-inner-wrapper {
      .header {
        font-size: 17px;
      }
      .sub-header {
        font-size: 12px;
      }
      .capture-and-share {
        font-size: 11px;
        margin-top: 15px;
      }
      .toggle-wrapper {
        margin-left: 0px;
      }
    }
  }
}

@media screen and (max-width: 320px) {
  .financial-card-wrapper {
    .financial-card-inner-wrapper {
      .header {
        width: 100px;
      }
    }
  }
}
</style>
